export default __webpack_public_path__ + "static/media/Legguards of Reckless Challenge.39d821a6.jpg";